export const isMobileDevice = () =>
  typeof navigator !== 'undefined' && navigator && Number(navigator.maxTouchPoints) > 0;
